import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1, A as ARROW_LEFT_24 } from './mapy-icon3.js';
import { g as getLocale, z as classNames, l as transDialog, k as getTheme } from './utils2.js';
import { k as MAX_PHOTOS_PER_LINE, h as MAX_TEXT_LENGTH, i as LAST_TEXT_LENGTH, d as DIALOG_PAGES } from './const.js';
import { d as defineCustomElement$9 } from './mapy-icon2.js';
import { d as defineCustomElement$8 } from './mapy-loader2.js';
import { d as defineCustomElement$7 } from './mapy-review-button2.js';
import { d as defineCustomElement$6 } from './mapy-review-dialog-footer2.js';
import { d as defineCustomElement$5 } from './mapy-review-photo-item2.js';
import { d as defineCustomElement$4 } from './mapy-review-photos-upload2.js';
import { d as defineCustomElement$3 } from './mapy-review-stars2.js';
import { d as defineCustomElement$2 } from './mapy-review-textarea2.js';

const mapyReviewDialogPageTextPhotoCss = ".mapy-review-dialog-page-text-photo{padding:0;display:flex;flex-direction:column;position:relative;height:100%;overflow:hidden;border-radius:12px}.header{display:flex;gap:8px;flex-direction:column;align-items:center;justify-content:center;width:100%}.header .title{margin:0;font-size:20px;font-style:normal;font-weight:700;line-height:28px;text-align:center;padding:0 25px}.back-button{padding:0;margin:0;position:absolute;left:12px;top:12px;border:none;background:transparent;color:#828282;border-radius:50%;cursor:pointer;z-index:10}.back-button mapy-icon{display:block}.back-button:hover,.back-button:focus{background:#f2f2f2}mapy-review-dialog-footer{width:100%}.textArea{width:100%;box-sizing:border-box}.textArea mapy-review-textarea{width:100%}.photos{width:100%}.scrollable{padding:48px 0 0 0;display:flex;flex-direction:column;gap:24px;justify-content:space-between;height:100%;box-sizing:border-box;font-family:Arial;align-items:center;position:relative;box-sizing:border-box;overflow:auto}.header,.textArea,.photos{width:100%;padding:0 32px;box-sizing:border-box}.footer{width:100%;padding:0 32px;box-sizing:border-box}.mapy-review-dialog-page-text-photo.is-sticky .scrollable{padding-top:23px}.mapy-review-dialog-page-text-photo.is-sticky .footer{position:sticky;left:0;right:0;bottom:0;background:#fff;z-index:10;padding-top:24px;box-shadow:0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2)}@media only screen and (max-width: 500px){.header,.textArea,.photos{width:100%;padding:0 16px;box-sizing:border-box}.footer{width:100%;padding:0 16px;box-sizing:border-box}.scrollable{padding:24px 0 0 0}.mapy-review-dialog-page-text-photo.is-sticky .footer{padding-top:16px}}";
const MapyReviewDialogPageTextPhotoStyle0 = mapyReviewDialogPageTextPhotoCss;

defineCustomElement$1();
const MapyReviewDialogPageTextPhoto = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogPageTextPhoto extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        this.back = createEvent(this, "back", 3);
        this.save = createEvent(this, "save", 1);
        this.photoLoading = createEvent(this, "photoLoading", 1);
        this.onBack = () => {
            this.back.emit(this.getSaveData());
        };
        this.onSignal = (signal) => {
            this.signal.emit(signal.detail);
        };
        this.onTextChange = (event) => {
            this.reviewText = event.detail;
        };
        this.onFooterSave = () => {
            this.onSave();
        };
        this.onSave = () => {
            this.save.emit(this.getSaveData());
        };
        this.onUploadStart = (event) => {
            this.photoError = "";
            this.photosAreLoading = true;
            this.photoLoading.emit(true);
            this.signal.emit({
                name: "upload-start",
                count: event.detail,
            });
        };
        this.onPhotosCountChange = (event) => {
            this.isSticky = event.detail > MAX_PHOTOS_PER_LINE;
        };
        this.onPhotosChange = (event) => {
            this.curPhotos = event.detail.photos;
            this.photosAreLoading = false;
            this.photoLoading.emit(false);
        };
        this.onBlurWithText = () => {
            this.signal.emit({
                name: "textarea-blur",
            });
        };
        this.onPhotosError = (event) => {
            this.photoError = event.detail.error;
        };
        this.loading = false;
        this.isFirm = false;
        this.rating = 0;
        this.error = "";
        this.backButton = true;
        this.maxLength = MAX_TEXT_LENGTH;
        this.lastLength = LAST_TEXT_LENGTH;
        this.endpoint = "";
        this.apiKey = "";
        this.text = "";
        this.debug = false;
        this.photos = [];
        this.service = "mapy";
        this.isResponsive = false;
        this.reviewText = "";
        this.isSticky = false;
        this.photosAreLoading = false;
        this.photoError = "";
        this.curPhotos = [];
    }
    getSaveData() {
        return {
            page: DIALOG_PAGES.TEXT_PHOTO,
            text: this.reviewText,
            media_ids: this.curPhotos.map(item => item.mediaId),
            photos: this.curPhotos,
        };
    }
    componentWillLoad() {
        this.reviewText = this.text;
        this.curPhotos = this.photos.slice();
    }
    render() {
        const locale = getLocale(this.hostElement);
        const theme = getTheme(this.service);
        return h(Host, { key: 'd36b0ad037d6d584975b43d6d622e598ed72a8c8' }, h("div", { key: 'ae39c814aeeaed945e7568810b851456cb0e3b26', class: classNames(["mapy-review-dialog-page-text-photo", this.isSticky || this.isResponsive ? "is-sticky" : ""]) }, (this.backButton && !this.photosAreLoading) && h("button", { type: "button", class: "back-button", onClick: this.onBack }, h("mapy-icon", { size: ARROW_LEFT_24.size }, h("path", { d: ARROW_LEFT_24.d }))), h("div", { key: '28a052885183922cd9f1bcd5fcffbb7555b88209', class: "scrollable" }, h("div", { key: 'c22658b84e4facd11a4f190b474fcbce71c53825', class: "header" }, h("mapy-review-stars", { key: '322fc4a32eb3434694b9777d791a19a470d6edef', value: this.rating, size: 20, gap: 3, disabled: true }), this.service === "mapy" && h("h3", { class: "title" }, transDialog(locale, "motivateToComment"))), h("div", { key: 'f9850f38d15cbbd5fcad87d42bb023035f6b8466', class: "textArea" }, h("mapy-review-textarea", { key: '0de29bd7caaec915a08c57cc4fce30bdc3a6ec8c', value: this.reviewText, onChange: this.onTextChange, height: theme === "mapy" ? 154 : 204, maxLength: this.maxLength, lastLength: this.lastLength, lang: locale, service: this.service, onBlurWithText: this.onBlurWithText })), h("div", { key: 'd8b9247c38c9f33d1eda9b0f524c908924f4cd80', class: "photos" }, h("mapy-review-photos-upload", { key: '9b53cf0bec38b86e717a3b7dc31c213e6bcea66c', endpoint: this.endpoint, apiKey: this.apiKey, photos: this.photos, debug: this.debug, onChange: this.onPhotosChange, onError: this.onPhotosError, onCountChange: this.onPhotosCountChange, onUploadStart: this.onUploadStart, lang: locale, service: this.service, onSignal: this.onSignal })), h("div", { key: '94d46b444a3d5791bfc68fcd62459065da944bc1', class: "footer" }, h("mapy-review-dialog-footer", { key: '2bf886a1050188c994748b01eb65c732d826fd64', isFirm: this.isFirm, hasButton: true, loading: this.loading, disabled: this.loading, lang: locale, service: this.service, hasPhotos: this.curPhotos.length > 0, onSave: this.onFooterSave, onSignal: this.onSignal, afterReview: true, hasReviewText: this.reviewText.length > 0, error: this.photoError || this.error })))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewDialogPageTextPhotoStyle0; }
}, [1, "mapy-review-dialog-page-text-photo", {
        "loading": [516],
        "isFirm": [516, "is-firm"],
        "rating": [514],
        "error": [513],
        "backButton": [516, "back-button"],
        "maxLength": [514, "max-length"],
        "lastLength": [514, "last-length"],
        "endpoint": [513],
        "apiKey": [513, "api-key"],
        "text": [513],
        "debug": [516],
        "photos": [16],
        "service": [513],
        "isResponsive": [516, "is-responsive"],
        "reviewText": [32],
        "isSticky": [32],
        "photosAreLoading": [32],
        "photoError": [32],
        "curPhotos": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-page-text-photo", "mapy-icon", "mapy-loader", "mapy-review-button", "mapy-review-dialog-footer", "mapy-review-photo-item", "mapy-review-photos-upload", "mapy-review-stars", "mapy-review-textarea"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-page-text-photo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogPageTextPhoto);
            }
            break;
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "mapy-review-dialog-footer":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "mapy-review-photo-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "mapy-review-photos-upload":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "mapy-review-stars":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "mapy-review-textarea":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogPageTextPhoto as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-dialog-page-text-photo2.js.map